export const SEVERITY_VALUES = [
  { value: 'NONE', name: 'NONE' },
  { value: 'MILD', name: 'MILD' },
  { value: 'MODERATE', name: 'MODERATE' },
  { value: 'SEVERE', name: 'SEVERE' },
];

export const SIDE_VALUES = [
  { value: 'LEFT', name: 'LEFT' },
  { value: 'RIGHT', name: 'RIGHT' },
];

export const HEMORRHAGIC_SIDE_VALUES = [
  { value: 'LEFT', name: 'LEFT' },
  { value: 'RIGHT', name: 'RIGHT' },
  { value: 'BRAINSTEM', name: 'BRAINSTEM' },
];

export const SIDE_VALUES_WITH_NONE = [{ value: 'NONE', name: 'NONE' }, ...SIDE_VALUES];

export const ARM_SEVERITY_VALUES = [
  { value: 0, name: '0' },
  { value: 1, name: '1' },
  { value: 2, name: '2' },
  { value: 3, name: '3' },
  { value: 4, name: '4' },
];

export const HEMI_NEGLECT_VALUES = [
  { value: 0, name: '0' },
  { value: 1, name: '1' },
  { value: 2, name: '2' },
];

export const CORTICAL_TYPES = [
  { value: 'FRONTAL', name: 'FRONTAL' },
  { value: 'PARIETAL', name: 'PARIETAL' },
  { value: 'TEMPORAL', name: 'TEMPORAL' },
  { value: 'OCCIPITAL', name: 'OCCIPITAL' },
];

export const SUBCORTICAL_TYPES = [
  { value: 'WHITE_MATTER', name: 'WHITE_MATTER' },
  { value: 'BASAL_GANGLIA', name: 'BASAL_GANGLIA' },
  { value: 'CEREBELLUM', name: 'CEREBELLUM' },
  { value: 'BRAINSTEM', name: 'BRAINSTEM' },
];

export const HEMORRHAGIC_SUBCORTICAL_TYPES = [
  { value: 'BASAL_GANGLIA', name: 'BASAL_GANGLIA' },
  { value: 'CEREBELLUM', name: 'CEREBELLUM' },
  { value: 'BRAINSTEM', name: 'BRAINSTEM' },
];

export function withEmtpyVal(values) {
  return [{ value: '', name: 'NONE' }, ...values];
}
